<template>
  <div class="inner_group" style="padding: 0 12px;">
    <div class="add_new_row flex flex-desk" style="margin-bottom: 0;">
      <div class="add_new_row_col1 w-100 marge-btm-22">
        <h3
          class="aprove_sur_title tx--blue ft--400"
          style="margin-bottom: 20px;"
        >
          מסמכים מצורפים
        </h3>
      </div>
      <div
        :class="{ 'grey-bottom': !isMobile }"
        class="add_new_row_col2 w-100 flex flex--top flex--start"
        style="margin-bottom: 0;"
      >
        <template v-if="documents && documents.length">
          <div
            class="app_info_docs"
            v-for="(doc, index) in documents"
            :key="index"
          >
            <a
              class="file_item relative flex desk-block"
              target="_blank"
              @click="getDoc(doc.path, doc.name)"
            >
              <span @click.stop="removeFile(index)" class="file-remove">
                <CloseSvg />
              </span>
              <img src="/assets/img/svg/file-doc.svg" />
              <span class="tx_file block" style="direction: rtl;">{{
                doc.name
              }}</span>
            </a>
          </div>
        </template>
        <div
          class="bt_upload relative flex flex--content--center bt_upload_info"
          @click="addDocuments"
        >
          <input type="text" />
          <div class="ic-upload ease">
            <UploadSvg />
          </div>
          <div class="tx_file ease">הוספת מסמך</div>
        </div>
      </div>
    </div>
    <div class="add_new_row flex flex-desk"></div>
  </div>
</template>

<script>
import UploadSvg from "../../../assets/img/svg/upload.svg";
import CloseSvg from "../../../assets/img/svg/close.svg";
import AddDocuments from "@/components/Popups/AddDocuments";
import ConfirmDelete from "@/components/Popups/ConfirmDelete.vue";
import Error from "@/components/Popups/Error";
import { downloadDocument } from "@/utilities/download-document";

export default {
  name: "AppDocuments",
  components: { UploadSvg, CloseSvg },
  props: {
    documents: {
      required: true
    },
    isMobile: {
      default: false
    }
  },
  methods: {
    async getDoc(url, name) {
      try {
        await downloadDocument(url, name);
      } catch (error) {
        this.$modal.show(Error);
      }
    },
    addDocuments() {
      this.$modal.show(AddDocuments);
    },
    removeFile(index) {
      this.$modal.show(ConfirmDelete, {
        onConfirm: () => {
          this.$emit("removeFile", index);
        }
      });
    }
  }
};
</script>
